/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import { useEffect, useState } from 'react';
import { Button, Container, Stack } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { InvitesTable } from '../../../components/accounts/invites/invitesTable';
import { TeamManagementTable } from '../../../components/accounts/team/teamManagementTable';
import { CLOUD, COCKPIT } from '../../../config/constants';
import { getInvites } from '../../../redux/slices/accounts/invites/invites';
import { getTeamMembers } from '../../../redux/slices/accounts/team/team';
import { getUserDetails } from '../../../redux/slices/user/userDetails';
import { fetchSubscriptionData } from '../../../redux/slices/subscriptionManagement/subscriptionManagement';
import { Link } from 'react-router-dom';
import { useTranslate } from '@tolgee/react';

const TeamManagement: React.FC = () => {
  const dispatch = useDispatch();
  const [type, setType] = useState(COCKPIT);
  const { t } = useTranslate();
  useEffect(() => {
    dispatch(fetchSubscriptionData() as unknown as AnyAction);
    dispatch(getUserDetails() as unknown as AnyAction);
    dispatch(getTeamMembers(CLOUD) as unknown as AnyAction);
    dispatch(getTeamMembers(COCKPIT) as unknown as AnyAction);
    dispatch(getInvites() as unknown as AnyAction);
  }, [dispatch]);
  // redux states
  const {
    cloud: { count },
    cockpit: { count: cockpitCount }
  } = useSelector((state: any) => state.team);
  const { count: invitesCount } = useSelector((state: any) => state.invites);
  const { data } = useSelector((state: any) => state.subscriptionManagement);

  const { hasSocialMediaManagementSubscription, hasCloudSubscription } =
    useSelector((state: any) => state.userDetails);

  return (
    <Container>
      {data && (
        <div className="d-flex">
          <div className="d-flex align-items-center justify-content-between w-100 py-3">
            <div className="d-flex">
              {hasSocialMediaManagementSubscription && (
                <div className={'d-flex bg-white p-2 shadow rounded fw-bold me-2'}>
                  {`${t('pages.accounts.team.team_cockpit_count')}: ${
                    (data.cockpit_users_count + 1) as string
                  } ${
                    data.max_cockpit_users_count
                      ? ` / ${(data.max_cockpit_users_count + 1) as string}`
                      : ''
                  }`}
                </div>
              )}

              {hasCloudSubscription && (
                <div className={'d-flex bg-white p-2 shadow rounded fw-bold'}>
                  {`${t('pages.accounts.team.team_cloud_count')}: ${
                    (data.cloud_users_count + 1) as string
                  } ${
                    data.max_cloud_users_count
                      ? ` / ${(data.max_cloud_users_count + 1) as string}`
                      : ''
                  }`}
                </div>
              )}
            </div>
            {data.available == null || data.available > 0 ? (
              <Link to="/accounts/team/invite/create/">
                <Button className="ms-auto" variant="primary" size="sm">
                  {t('pages.accounts.team.add_member')}
                </Button>
              </Link>
            ) : (
              <Button
                className="ms-auto"
                variant="primary"
                size="sm"
                onClick={() =>
                  (window.location.href = '/subscription-management/select/')
                }
              >
                {t('pages.accounts.team.upgrade_subscription')}
              </Button>
            )}
          </div>
        </div>
      )}

      <div className="card p-2 rounded">
        <Stack direction={'horizontal'} gap={3}>
          {hasSocialMediaManagementSubscription && (
            <Button
              variant="light"
              className={`${type === COCKPIT ? 'btn-light-primary' : ''}`}
              size="sm"
              onClick={() => {
                setType(COCKPIT);
              }}
            >
              {t(COCKPIT)}
              <div className="badge badge-light-success ms-2">
                {cockpitCount}
              </div>
            </Button>
          )}
          {hasCloudSubscription && (
            <Button
              variant="light"
              size="sm"
              className={`${type === CLOUD ? 'btn-light-primary' : ''}`}
              onClick={() => {
                setType(CLOUD);
              }}
            >
              {t(CLOUD)}
              <div className="badge badge-light-success ms-2">{count}</div>
            </Button>
          )}

          <Button
            variant="light"
            size="sm"
            className={`${type === 'invites' ? 'btn-light-primary' : ''}`}
            onClick={() => {
              setType('invites');
            }}
          >
            {t('pages.accounts.team.invites')}{' '}
            <div className="badge    badge-light-success ms-2">
              {invitesCount}
            </div>
          </Button>
        </Stack>
        {type === 'invites' ? (
          <InvitesTable type={'invites'} />
        ) : (
          <TeamManagementTable type={type} />
        )}
      </div>
    </Container>
  );
};
export default TeamManagement;
